import { render, staticRenderFns } from "./SmartSearchResults.vue?vue&type=template&id=f54dabbc&"
import script from "./SmartSearchResults.vue?vue&type=script&lang=js&"
export * from "./SmartSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./SmartSearchResults.vue?vue&type=style&index=0&id=f54dabbc&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f54dabbc')) {
      api.createRecord('f54dabbc', component.options)
    } else {
      api.reload('f54dabbc', component.options)
    }
    module.hot.accept("./SmartSearchResults.vue?vue&type=template&id=f54dabbc&", function () {
      api.rerender('f54dabbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/SmartSearchResults.vue"
export default component.exports